/*
 * @Author: cc
 * @Date: 2019-12-24 19:17:43
 * @LastEditTime: 2021-10-13 10:46:17
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\app\toBeCompiled\website\editCenter_website.js
 * @Description: 网站链接稿
 */

'use strict';
angular.module('editingCenterAddWebsiteModule', []).controller('EditingCenterAddWebsiteController', [
    '$scope',
    'beforeonload',
    '$compile',
    '$element',
    '$sce',
    '$q',
    '$state',
    '$window',
    'trsHttpService',
    'initAddMetaDataService',
    '$filter',
    '$timeout',
    'storageListenerService',
    'trsSelectDocumentService',
    'jsonArrayToStringService',
    'modalDialog',
    '$validation',
    'initeditctrBtnsService',
    'editingCenterAppService',
    'editingCenterService',
    'initAppRequiredBtnService',
    'editcenterRightsService',
    'filterEditctrBtnsService',
    'appDictionaryBtnService',
    'editIsLock',
    'sensitiveWordCheckService',
    'trsspliceString',
    'globleParamsSet',
    'newMediaService',
    'appConst',
    'messagePublishService',
    function(
        $scope,
        beforeonload,
        $compile,
        $element,
        $sce,
        $q,
        $state,
        $window,
        trsHttpService,
        initAddMetaDataService,
        $filter,
        $timeout,
        storageListenerService,
        trsSelectDocumentService,
        jsonArrayToStringService,
        modalDialog,
        $validation,
        initeditctrBtnsService,
        editingCenterAppService,
        editingCenterService,
        initAppRequiredBtnService,
        editcenterRightsService,
        filterEditctrBtnsService,
        appDictionaryBtnService,
        editIsLock,
        sensitiveWordCheckService,
        trsspliceString,
        globleParamsSet,
        newMediaService,
        appConst,
        messagePublishService
    ) {

        /* 初始化*/
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.status = {
                pictureSize: {},
                newsFormError: [],
                switch: 'manuscriptInfo', // 默认选中稿件信息
                openBtn: true,
                isCheckSensitiveWords: false,
                sensitiveWordTit: '敏感词校验',
                isSecondReview: false,
                isSignedOrRevoked: false,
                isEditDraft: !!$state.params.appmetadataid,
                position: $state.params.appplatform,
                heimaCheckTit: '错别字校对',
                hasReleOfficials: false,

                /* releOfficialsTimeout: false, //等待相关官员数据加载完成
                    belongChannelTimeout: false, //等待关联栏目数据加载完成*/
                isFusionEditor: $state.current.name == 'fusionlinkdoc', // 是否来自融合编辑器
                showFgd: false, // 是否显示发稿单
                isawaitrevise: $state.params.isawaitrevise,
                hasTitleSynced: false, // 标题是否已经同步给列表标题
            };
            $scope.status.hasVersionTime = !!angular.isDefined($state.params.appchnldocid);
            $scope.data = {
                specialDoc: 0,
                userName: '',
                trench: appConst.params.listenStroageKey,
                copyVersion: [],
                srcUrl: '', // 由稿件链接生成的稿件页面
                commentSet: editingCenterAppService.initCommentSet(),
                listStyle: editingCenterAppService.initListStyle('addZTPIC'),
                label: '',
                path: {
                    '-1': 'editingCenterIwoPersonalVersionTime',
                    '1': 'editingCenterAppPersonalVersionTime',
                    '2': 'editingCenterWebsitePersonalVersionTime',
                    '3': 'editingCenterPaperPersonalVersionTime',
                    '4': 'editingCenterWeixinPersonalVersionTime',
                },
                relNewsSelectedItems: [],
                relSubjectSelectedItems: [],
                relSubjectGroup: [], // 相关专题分组
                relSubjectSelectedGroup: [], // 相关专题所选分组
                selectNewArray: [], // 相关新闻选中数据
                selectSubjectArray: [], // 相关专题选中数据
                versionTime: [],
                copyDraft: [],
                copyDraftLog: [],
                Channel: [],
                voiceObj: {},
                docGenre: editingCenterAppService.initDocGenre(),
                comment: {
                    comment: [],
                    voiceObj: {},
                    hasMore: false,
                    currPage: 1,
                },
                listPicRatio: {
                    set: {
                        0: '',
                        1: '',
                        2: '',
                    },
                    practical: {
                        0: '1',
                        1: '1',
                        2: '1',
                    },
                },
                focusRatio: {
                    set: '',
                    practical: '1',
                },
                bigPicRtion: {
                    set: '', // 大图只需要设置的值不需要单独实际值，因为大图使用的是列表图的第一张
                },
                specZtPicRtion: {
                    set: '', // 窄图
                },
            };
            if ($scope.status.isFusionEditor) {
                $scope.params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'getAPPFusionDoc',
                    sourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                };
            } else {
                $scope.params = {
                    serviceid: 'mlf_appmetadata',
                    methodname: 'getLinkDoc',
                    ChnlDocId: $state.params.appchnldocid,
                };
            }
            $scope.handleBtnClick = function(funname) {
                eval('$scope.' + funname + '()');
            };
            emitCloseWindow();
            // 初始化标签
            editingCenterAppService.initTag($state.params.appsiteid).then(function(list) {
                $scope.data.label = angular.copy(list);
            });
            $scope.editFlag = {
                media: 'app',
                docType: 'linkdoc',
            };
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function() {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.webForm.$error) {
                errorArray.push(error);
            }
            $scope.status.newsFormError = $scope.status.newsFormError == undefined ? [] : $scope.status.newsFormError;
            if ($scope.status.newsFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.newsFormError = errorArray;
            }
            return $scope.status.newsFormError; // 返回
        };

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            editingCenterService.allAppCloseWindow($scope, {typeName: 'app', saveLocal: false, hascondition: true});
        }

        /**
         * [initData description]初始化数据
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            if ($scope.status.isawaitrevise) {
                editcenterRightsService.initIwoListBtn('iwo.xiuding').then(function(rights) {
                    $scope.status.btnRights = rights;
                });
            }
            if (!$scope.status.isFusionEditor) {
                (angular.isDefined($state.params.appchnldocid) ? initEditData() : initNewData()).then(function() {
                    getSiteConfig();
                    beforeonload.beforeonloadAlert($scope);
                });
                initBtnArray();
                getCutPictureWidthHeight();
            } else {
                getFusionEditorCutPictureWidthHeight();
            }
            // 融合编辑器下获取评审意见
            if ($state.params.iwometadataid) {
                getComment($state.params.iwometadataid, $scope.data.comment.currPage);
            }
        }

        /**
         * [getComment description]获取评审意见
         * @param   {[type]}  id        [id description]
         * @param   {[type]}  currPage  [currPage description]
         * @return  {[type]}            [return description]
         */
        function getComment(id, currPage) {
            editingCenterService.getComment(id, currPage).then(function(data) {
                if (
                    angular.isDefined($scope.data.comment.comment[$scope.data.comment.comment.length - 1]) &&
                    $filter('date')($scope.data.comment.comment[$scope.data.comment.comment.length - 1].day, 'yyyy-MM-dd').toString() ==
                        $filter('date')(data.comment[0].day, 'yyyy-MM-dd').toString()
                ) {
                    $scope.data.comment.comment[$scope.data.comment.comment.length - 1].times = $scope.data.comment.comment[
                        $scope.data.comment.comment.length - 1
                    ].times.concat(data.comment[0].times);
                    data.comment.shift();
                }
                $scope.data.comment['comment'] = $scope.data.comment['comment'].concat(data.comment);
                $scope.data.comment.hasMore = data.hasMore;
                for (var i in data.voiceObj) {
                    $scope.data.comment.voiceObj[i] = data.voiceObj[i];
                }
            });
        }

        /**
         * [getComment description]获取评审意见
         * @return {[type]} [description]
         */
        $scope.getLoadMoreComment = function() {
            $scope.data.comment.currPage += 1;
            getComment($state.params.iwometadataid, $scope.data.comment.currPage);
        };

        /**
         * [loadDirective description]动态加载指令app
         * @return  {[type]}  [return description]
         */
        function loadDirective() {
            if (!$scope.status.isFusionEditor) {
                editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
                var draftList =
                    '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="webForm"></editor-dir>' +
                    '<editor-auth-dir author="list.FGD_AUTHINFO"></editor-auth-dir>';
                draftList = $compile(draftList)($scope);
                $element.find('editor').append(draftList);
            }
        }

        /**
         * [getCutPictureWidthHeight description]获取图片编辑默认宽高
         * @return {[type]} [description]
         */
        function getCutPictureWidthHeight() {
            editingCenterService.querySettedPicSize('app').then(function (data) {
                var pictureSizeArr = ['WEBPAGESIZE', 'FOCUSIMAGESIZE', 'WEBPAGEBIGSIZE', 'WEBZTPICSIZE'];
                var pictureSizeObj = editingCenterAppService.resetPicSize(pictureSizeArr, data);
                // 将返回来的值进行复制到本身控制器里显示
                dealPictureSize(pictureSizeArr, pictureSizeObj);
            });
        }

        /**
         * [dealPictureSize description]处理图片返回的比例操作
         *
         * @param   {[type]}  pictureSizeArr  [pictureSizeArr description]
         * @param   {[type]}  pictureSizeObj  [pictureSizeObj description]
         *
         * @return  {[type]}                  [return description]
         */
        function dealPictureSize(pictureSizeArr, pictureSizeObj) {
            pictureSizeArr.forEach(function (value, item) {
                $scope.status.pictureSize[value] = pictureSizeObj[value];
            });
            $scope.data.listPicRatio.set = pictureSizeObj.ratio.WEBPAGESIZE;
            $scope.data.focusRatio.set = pictureSizeObj.ratio.FOCUSIMAGESIZE;
            $scope.data.bigPicRtion.set = pictureSizeObj.ratio.WEBPAGEBIGSIZE;
            $scope.data.specZtPicRtion.set = pictureSizeObj.ratio.WEBZTPICSIZE;
        }

        /**
         * [getFusionEditorCutPictureWidthHeight description]给融合编辑器添加一个默认的比例
         * @return {[type]} [description]
         */
        function getFusionEditorCutPictureWidthHeight() {
            var pictureSizeArr = ['WEBPAGESIZE', 'FOCUSIMAGESIZE', 'WEBPAGEBIGSIZE', 'WEBZTPICSIZE'];
            var pictureSizeObj = editingCenterAppService.resetPicSize(pictureSizeArr);
            // 将返回来的值进行复制到本身控制器里显示
            dealPictureSize(pictureSizeArr, pictureSizeObj);
        }


        /**
         * [getSiteConfig description]获取站点的配置信息
         * @return {[type]}           [description]
         */
        function getSiteConfig() {
            var params = {
                serviceid: 'mlf_appmetadata',
                methodname: 'findAppSiteById',
                SiteId: $state.params.appsiteid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status.manuAttr = {
                    relatedTopic: data.RELATEDTOPIC,
                    connectionColumn: data.CONNECTIONCOLUMN,
                    relatedOfficial: data.RELATEDOFFICIAL,
                };
                initRelatedColumnData();
                initRelatedOfficials();
            });
        }

        /**
         * [initRelatedOfficials description] 初始化相关官员
         * @return {[type]} [description]
         */
        function initRelatedOfficials() {
            if ($scope.status.manuAttr.relatedOfficial != 1) {
                return;
            }
            $scope.status.relatedOfficial = !!(angular.isArray($scope.list.RELEVANTOFFICIALSIDS) && $scope.list.RELEVANTOFFICIALSIDS.length > 0);
            let params = {
                serviceid: 'mlf_appexchange',
                methodname: 'getZJXWOfficers',
                SiteId: $state.params.appsiteid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                $scope.data.relatedOfficialList =
                    angular.isObject(resp) && angular.isObject(resp.DATA) && angular.isArray(resp.DATA.officer_list) ? resp.DATA.officer_list : [];
                if (!angular.isArray($scope.list.RELEVANTOFFICIALSIDS)) {
                    return;
                }
                $scope.data.selectedOfficial = $scope.data.relatedOfficialList.filter((item) =>
                    $scope.list.RELEVANTOFFICIALSIDS.some((_item) => _item == item.id)
                );
            });
        }

        /**
         * [closeRelatedOfficial description] 关闭相关官员选项
         * @return {[type]} [description]
         */
        $scope.closeRelatedOfficial = function() {
            if (!$scope.status.relatedOfficial) {
                $scope.status.relatedOfficial = true;
                if (!angular.isArray($scope.data.selectedOfficial)) {
                    return;
                }
                $scope.list.RELEVANTOFFICIALSIDS = $scope.data.selectedOfficial.map((item) => item.id + '');
            } else {
                $scope.status.relatedOfficial = false;
                $scope.list.RELEVANTOFFICIALSIDS = [];
            }
        };

        /**
         * [selectedOfficials description] 选中了相关官员
         * @return {[type]} [description]
         */
        $scope.selectedOfficials = function() {
            $scope.list.RELEVANTOFFICIALSIDS = $scope.data.selectedOfficial.map((item) => item.id + '');
        };

        /**
         * [initRelatedColumnData description] 初始化相关栏目数据，以适应级联菜单
         * @return {[type]} [description]
         */
        function initRelatedColumnData() {
            if ($scope.status.manuAttr.connectionColumn == 1) {
                $scope.status.relatedColumn = [
                    [
                        {
                            name: $scope.list.BELONGCHANNEL.TYPE,
                            id: $scope.list.BELONGCHANNEL.ID,
                        },
                        {
                            name: $scope.list.BELONGCHANNEL.NAME,
                            id: $scope.list.BELONGCHANNEL.VALUE,
                        },
                    ],
                ];
            }
        }

        /**
         * [getZJXWColumns description] 获取相关栏目列表
         * @return {[type]} [description]
         */
        $scope.getZJXWColumns = function() {
            let deffer = $q.defer();
            let params = {
                serviceid: 'mlf_appexchange',
                methodname: 'getZJXWColumns',
                SiteId: $state.params.appsiteid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                let treeData = (() => {
                    if (
                        !angular.isObject(resp) ||
                        !angular.isObject(resp.DATA) ||
                        !angular.isArray(resp.DATA.all_columns) ||
                        resp.DATA.all_columns.length == 0
                    ) {
                        return [];
                    }
                    return resp.DATA.all_columns.map((item, index) => ({
                        id: item.id,
                        name: item.type,
                        CHILDREN: item.column_list.map((item_, index_) => {
                            item_.hasChildren = 0;
                            return item_;
                        }),
                    }));
                })();
                deffer.resolve(treeData);
            });
            return deffer.promise;
        };

        /**
         * [selectRelatedColumn description] 选中相关栏目
         * @return {[type]} [description]
         */
        $scope.selectRelatedColumn = function() {
            $scope.list.BELONGCHANNEL =
                angular.isArray($scope.status.relatedColumn) &&
                angular.isArray($scope.status.relatedColumn[0]) &&
                $scope.status.relatedColumn[0][1].id
                    ? {
                        ID: $scope.status.relatedColumn[0][0].id,
                        TYPE: $scope.status.relatedColumn[0][0].name,
                        NAME: $scope.status.relatedColumn[0][1].name,
                        VALUE: $scope.status.relatedColumn[0][1].id,
                    }
                    : {};
        };

        /**
         * [initNewData description]初始化新建页面
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        function initNewData(dealWithListFun) {
            var deffer = $q.defer();
            editingCenterAppService.initTag($state.params.appsiteid).then(function(list) {
                $scope.list = initAddMetaDataService.initWebsite();
                $scope.list.LABEL = list.length === 0 ? '' : list[0].value;
                $scope.list.ORIGINAL = '0';
                // 融合编辑器下处理list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
                loadDirective();
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [initEditData description]初始化编辑页面
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        function initEditData(dealWithListFun) {
            var defer = $q.defer();
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.list = data;
                document.title = data.TITLE;
                if (!data.LISTSTYLE) {
                    $scope.list.LISTSTYLE = '2'; // 网站多元分发过来的新闻、链接、图集稿件，列表样式默认选择文字。
                }
                $scope.status.isSecondReview = !!(angular.isDefined(data.ISSECONDREVIEW) && data.ISSECONDREVIEW == '1');
                $scope.data.srcUrl = $sce.trustAsResourceUrl(data.URL);
                reWriteImg();
                initRelavantSpecialDoc();
                syncTitleToListTitle();
                // 如果稿件返回了发稿单信息，则展示发稿单
                if ($scope.status.isFusionEditor) {
                    // 融合编辑器下处理list
                    if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                        dealWithListFun();
                    }
                    // 获取流程版本与操作日志
                    getVersion().then(function() {
                        defer.resolve();
                    });
                    getPropagandaReview();
                } else if (data.FUSION == 'true') {
                    $scope.status.showFgd = true;
                    loadDirective();
                    getVersion();
                    getPropagandaReview();
                    $timeout(function() {
                        var fgdHeight = $('.app_manuscript_partfour').height();
                        var fgdWidth = $('.app_manuscript_partfour').width();
                        $('.fgdCantEdit')
                            .find('.cantEditPart')
                            .height(fgdHeight)
                            .width(fgdWidth);
                        $('.app_manuscript_partfour').resize(function() {
                            $('.fgdCantEdit')
                                .find('.cantEditPart')
                                .height($(this).height());
                        });
                    });
                    defer.resolve();
                } else {
                    loadDirective();
                    getVersion();
                    getPropagandaReview();
                    defer.resolve();
                }
            });
            // 稿件加锁
            editIsLock.lockDraft($state.params.appmetadataid);
            return defer.promise;
        }

        /**
         * [getBelongChannel description] 获取关联栏目列表
         * @return {[type]} [description]
         */
        /* function getBelongChannel() {
                var params = {
                    serviceid: "mlf_appexchange",
                    methodname: "getZJXWColumns"
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    try {
                        angular.forEach(data, function(value, index) {
                            value.ID = value.TYPE;
                            value.NAME = value.TYPE;
                            if (angular.isDefined($scope.list.BELONGCHANNEL) && $scope.list.BELONGCHANNEL.TYPE == value.TYPE) {
                                $scope.data.selectedChannel = {
                                    NAME: $scope.list.BELONGCHANNEL.TYPE,
                                    ID: $scope.list.BELONGCHANNEL.TYPE
                                };
                                $scope.data.selectedChildrenChannel = {
                                    NAME: $scope.list.BELONGCHANNEL.NAME,
                                    ID: $scope.list.BELONGCHANNEL.VALUE
                                };
                            }
                        });
                        $scope.data.belongChannel = data;
                        $scope.status.belongChannelTimeout = true;
                    } catch (err) {
                        $scope.status.belongChannelTimeout = true;
                        console.log('新疆新闻的相关接口可能正在更新，无法获取关联栏目列表信息，请稍后再试。');
                    }
                }, function() {
                    $scope.status.belongChannelTimeout = true;
                    console.log('新疆新闻的相关接口可能正在更新，无法获取关联栏目列表信息，请稍后再试。');
                });
            }*/

        /**
         * [initRelavantSpecialDoc description] 初始化相关专题
         * @return {[type]} [description]
         */
        function initRelavantSpecialDoc() {
            if (angular.isDefined($scope.list.RELEVANTSPECIALDOC) && $scope.list.RELEVANTSPECIALDOC.length != 0) {
                angular.forEach($scope.list.RELEVANTSPECIALDOC, function(data, index) {
                    $scope.data.relSubjectSelectedItems.push({
                        METADATAID: data.METADATAID,
                        LISTTITLE: data.LISTTITLE,
                        SPECIALGROUPID: data.SPECIALGROUPID,
                    });
                    $scope.data.relSubjectSelectedGroup.push({
                        name: data.SPECIALGROUPNAME,
                        value: data.SPECIALGROUPID,
                    });
                });
                var i = 0;
                initRelSubjectGroup($scope.list.RELEVANTSPECIALDOC[i]);
            }

            /**
             * [initRelSubjectGroup description] 初始化相关专题稿件的分组
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            function initRelSubjectGroup(item) {
                var params = {
                    methodname: 'querySpecialGroupsFromData',
                    serviceid: 'mlf_specialgroup',
                    MetaDataId: item.METADATAID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.relSubjectGroup[i] = data.DATA;
                    angular.forEach($scope.data.relSubjectGroup[i], function(value, key) {
                        value.name = value.SPECIALGROUPNAME;
                        value.value = value.SPECIALGROUPID;
                    });
                    i++;
                    if (i < $scope.list.RELEVANTSPECIALDOC.length) {
                        initRelSubjectGroup($scope.list.RELEVANTSPECIALDOC[i]);
                    }
                });
            }
        }

        /**
         * [reWriteImg description]回写图片列表数据
         * @return {[type]} [description]
         */
        function reWriteImg() {
            var imgArray = ['FOCUSIMAGE', 'LISTPICS'];
            angular.forEach(imgArray, function(data, index) {
                if ($scope.list[data] !== 0) {
                    var arrayDocPic = [];
                    angular.forEach($scope.list[data], function(dataC, indexC) {
                        arrayDocPic.push({
                            APPFILE: dataC.APPFILE,
                            APPDESC: dataC.APPDESC,
                            PERPICURL: dataC.PERPICURL,
                        });
                    });
                    $scope.list[data] = arrayDocPic;
                }
            });
        }

        /**
         * 网页稿重构开始
         */
        /**
         * [updateCKSelection description]单选框回调函数
         * @param  {[str]} attribute [description]需要改变的属性
         * @return {[type]}           [description]
         */
        $scope.updateCKSelection = function (attribute) {
            // if (attribute === 'ISFOCUSIMAGE' && $state.params.appplatform === '2') {
            //     modalDialog.alertType('', '稿件已签发后，无法勾选或取消勾选栏目焦点图', 'error', false, function() {});
            //     return;
            // }
            $scope.list[attribute] = $scope.list[attribute] == '0' ? '1' : '0';
        };

        /**
         * [checkReleOfficials description] 相关官员开关
         * @return {[type]} [description]
         */
        $scope.checkReleOfficials = function() {
            if ($scope.status.hasReleOfficials === true) {
                $scope.status.hasReleOfficials = false;
            } else {
                $scope.status.hasReleOfficials = true;
            }
        };

        /**
         * [showReleOfficialsValue description] 用于页面表单校验相关官员是否有数据
         * @return {[type]} [description]
         */
        $scope.showReleOfficialsValue = function() {
            $scope.data.releOfficialsValue = trsspliceString.spliceString($scope.data.selectedReleOfficials, 'ID', ',');
        };

        /**
         * [deleteUploaderImg description]删除已经上传的图片
         * @param  {[str]} attribute [description]要删除的属性
         * @param  {[num]} index     [description]下标
         * @return {[type]}           [description]
         */
        $scope.deleteUploaderImg = function(attribute, index) {
            if (attribute === 'LISTPICS') {
                $scope.list[attribute][index] = {
                    APPFILE: '',
                    APPDESC: '',
                    PERPICURL: '',
                };
            } else {
                $scope.list[attribute] = [];
            }
        };

        /**
         * [save description] 保存函数
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.save = function(type) {
            type = angular.isDefined(type) ? type : true;
            var deffer = $q.defer();
            save(type).then(
                function() {
                    if ($scope.$root.cureditpage === undefined || $scope.$root.cureditpage === 'appwebsite') {
                        if (type === true){
                            editIsLock.lockDraft($state.params.appmetadataid);   
                        }
                        getVersion($scope.list.METADATAID);
                    }
                    deffer.resolve();
                },
                function() {
                    deffer.reject();
                }
            );
            return deffer.promise;
        };

        /**
         * [getVersion description]获取流程版本与操作日志
         * @return {[type]} [description]
         */
        function getVersion(id) {
            var defer = $q.defer();
            var metadataid = angular.isDefined(id) ? id : $state.params.appmetadataid;
            metadataid = $state.params.iwometadataid ? $state.params.iwometadataid : metadataid;
            editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(function(data) {
                $scope.data.version = data;
                $scope.page = data.page;
                $scope.data.copyVersion = data.copyArray;
                $scope.status.hasVersionTime = true;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
         * @param  {[type]}  key [description] 操作日志或流程版本的数据
         * @return {Boolean}     [description]
         */
        $scope.isShowVersion = function(key) {
            if (key === undefined) {
                return false;
            } else {
                for (var i in key) {
                    return true;
                }
                return false;
            }
        };

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function() {
            $scope.page.CURRPAGE++;
            getVersion();
        };

        /**
         * 获取宣传部评审流程
         */
        function getPropagandaReview() {
            var deffer = $q.defer();
            editingCenterService.getPropagandaReview(1, $state.params.appmetadataid).then(function(data) {
                $scope.data.propagandaReview = data;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function(item) {
            var path = $scope.data.path[item.MEDIATYPE];
            var params = {
                objectversionid: item.OBJECTVERSIONID,
                chnldocid: $state.params.appchnldocid,
            };
            var url = $state.href(path, params);
            item.url = url;
        };

        /**
         * [appTrial description]APP送审操作
         * @return {[type]} [description]
         */
        $scope.appTrial = function() {
            trial();
        };

        /**
         * [trial description]稿件送审
         * @return {[type]} [description]
         */
        function trial() {
            newMediaService.trial($scope, appConst.params.trialParams).then((opinion) => {
                $scope.save().then(function () {
                    let trialParams = angular.extend({
                        MetaDataIds: $scope.list.METADATAID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        ChannelId: $state.params.appchannelid,
                        Opinion: opinion,
                    }, appConst.params.trialParams);
                    messagePublishService.publish('doEditPageOperation', trialParams);
                });
            });
        }

        /**
         * [appSignDirect description]app直接签发
         * @return {[type]} [description]
         */
        $scope.appSignDirect = function() {
            signDirect();
        };

        /**
         * [signDirect description] 直接签发
         * @param   {[type]}  isSaveAndPublish  [isSaveAndPublish description]
         * @return  {[type]}                    [return description]
         */
        function signDirect(isSaveAndPublish) {
            var array = [$scope.list];
            if (isSaveAndPublish) {
                signPrivate();
            } else {
                sensitiveWordCheckService.SensitiveWordsAndCareful(array, true, '1').then(
                    function() {
                        signPrivate();
                    },
                    function() {
                        signPrivate();
                    }
                );
            }

        }

        /**
         * [signPrivate description]
         * @return  {[type]}  [return description]
         */
        function signPrivate() {
            var methodname = ['appDaiBianPublish', 'appDaiShenPublish', 'appYiQianFaPublish'];
            $scope.loadingPromise = newMediaService.sign($scope).then(function() {
                $scope.save().then(() => {
                    let signParams = {
                        serviceid: 'mlf_appoper',
                        methodname: methodname[$state.params.appplatform],
                        ObjectIds: $scope.list.CHNLDOCID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                    };
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        }

        /**
         * [appSignTiming description]定时签发
         * @return {[type]} [description]
         */
        $scope.appSignTiming = function() {
            if ($scope.status.isSecondReview === true) {
                modalDialog.alertType('无法进行操作', '该稿件处于二次送审流程中，不能定时签发', 'warning', 'confirm');
                return;
            }
            timeSign();
        };

        /**
         * [timeSign description]定时签发函数
         * @return {[type]} [description]
         */
        function timeSign() {
            var methodname = ['appDaiBianTimingPublish', 'appDaiShenTimingPublish'];
            $scope.loadingPromise = newMediaService.timeSign($scope).then(function() {
                $scope.save(false).then(() => {
                    let signParams = {
                        serviceid: 'mlf_appoper',
                        methodname: methodname[$state.params.appplatform],
                        ObjectIds: $scope.list.CHNLDOCID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                    };
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        }

        /**
         * [appPreview description]稿件预览
         * @return {[type]} [description]
         */
        $scope.appPreview = function() {
            $scope.save(false).then(function(data) {
                editIsLock.lockDraft($state.params.appmetadataid);
                mobilePreview();
            });
        };

        /**
         * [mobilePreview description]手机端预览方法
         * @return {[type]} [description]
         */
        function mobilePreview() {
            $scope.loadingPromise = editingCenterAppService.appPrevewPublish($state.params.appchnldocid).then(
                function() {},
                function() {
                    editIsLock.lockDraft($state.params.appmetadataid);
                }
            );
        }

        /**
         * [appRevoke description]稿件撤稿
         * @return {[type]} [description]
         */
        $scope.appRevoke = function() {
            revoke();
        };

        /**
         * [revoke description]撤稿函数
         * @return {[type]} [description]
         */
        function revoke() {
            newMediaService.rejection($scope, appConst.params.rejectionParams).then((opinion) => {
                $scope.save().then(function () {
                    let KillParams = angular.extend({
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                        Opinion: opinion,
                        ChannelId: $state.params.appchannelid,
                    }, appConst.params.rejectionParams);
                    messagePublishService.publish('doEditPageOperation', KillParams);
                });
            });
        }

        /**
         * [appSavePublish description]保存并发布
         * @return {[type]} [description]
         */
        $scope.appSavePublish = function() {
            // save().then(function(data) {
            signDirect(true);
            // });
        };

        /**
         * [revise description] 修订
         * @return {[type]} [description]
         */
        $scope.revise = function() {
            modalDialog.confirmModal('修订', '确认修订?', function() {
                save().then(
                    function() {
                        var params = {
                            serviceid: 'mlf_modifydoc',
                            methodname: 'paperModifyDocsFinished',
                            PaperDocIds: $state.params.appmetadataid,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                            function(data) {
                                modalDialog.alertType(
                                    '修订成功',
                                    '',
                                    'success',
                                    false,
                                    function() {
                                        storageListenerService.addListenerToNewspaper('xiuding');
                                        $window.close();
                                    },
                                    '',
                                    1500
                                );
                            },
                            function(data) {
                                editIsLock.lockDraft($state.params.appmetadataid);
                            }
                        );
                    },
                    function() {
                        editIsLock.lockDraft($state.params.appmetadataid);
                    }
                );
            });
        };

        /**
         * [close description]关闭页面
         * @return {[type]} [description]
         */
        $scope.close = function() {
            editingCenterService.closeWinow($scope.webForm.$dirty, false).then(
                function() {
                    save().then(function() {
                        storageListenerService.addListenerToApp('save');
                        editIsLock.normalLock($state.params.appmetadataid).then(function(data) {
                            $window.open('about:blank', '_self').close();
                        });
                    });
                },
                function() {
                    angular.isDefined($state.params.appmetadataid)
                        ? editIsLock.normalLock($state.params.appmetadataid).then(function(data) {
                            $window.open('about:blank', '_self').close();
                        })
                        : $window.open('about:blank', '_self').close();
                }
            );
        };
        // 浏览器关闭
        $window.onunload = onbeforeunload_handler;

        /**
         * [onbeforeunload_handler description]
         * @return  {[type]}  [return description]
         */
        function onbeforeunload_handler() {
            editIsLock.normalLock($state.params.appmetadataid).then(function(data) {
                $window.open('about:blank', '_self').close();
            });
        }

        /**
         * [dealAttributeBeforeSave description]在保存前处理数据
         * @return {[type]} [description]
         */
        function dealAttributeBeforeSave() {
            $scope.webForm.$setPristine();
            $scope.status.openBtn = false;
            getRelavantSpecialDoc();
            $scope.list.SPECIALMANUSCRIPT = $scope.data.specialManuscript;
            // 根据列表样式过滤多余的图片信息
            if ($scope.list.LISTSTYLE == '2') {
                $scope.list.LISTPICS = [];
            } else if ($scope.list.LISTSTYLE == '0') {
                $scope.list.LISTPICS = [].concat(angular.copy($scope.list.LISTPICS[0]));
            }
            $scope.list.CUSTOMTIME = globleParamsSet.filterTime($scope.list.CUSTOMTIME, 'yyyy-MM-dd HH:mm');
            var list = angular.copy($scope.list);
            list.CONTRIBUTORSAUTHER = $scope.data.userName;
            list.LISTPICS = angular.copy(jsonArrayToStringService.clearEmptyArray(list.LISTPICS));
            list.ORIGINALTYPE = $scope.data.originType;
            list.SPECIALDOC = $scope.data.specialDoc;
            if ($scope.status.isFusionEditor) {
                delete list.ISNOPAYMENT;
                delete list.FGD_EDITINFO;
                delete list.FGD_AUTHINFO;
                delete list.DOCGENRE;
                list.METADATAID = $state.params.appmetadataid || '0';
                list.serviceid = 'mlf_fusionapp';
                list.methodname = 'saveFictisionsLinkDoc';
                list.SourceDocId = $scope.data.sourceDocId || $state.params.iwometadataid;
            } else {
                list.serviceid = 'mlf_appmetadata';
                list.methodname = 'saveLinkDoc';
            }
            list = jsonArrayToStringService.jsonArrayToString(list);
            return list;
        }

        /**
         * [getRelavantSpecialDoc description] 获取相关专题
         * @return {[type]} [description]
         */
        function getRelavantSpecialDoc() {
            darftRemove($scope.data.relSubjectSelectedItems, [], 'SPECIALGROUPID', function(index) {
                $scope.data.relSubjectSelectedItems.splice(index, 1);
                $scope.data.relSubjectGroup.splice(index, 1);
                $scope.data.relSubjectSelectedGroup.splice(index, 1);
            });
            $scope.list.RELEVANTSPECIALDOC = [];
            angular.forEach($scope.data.relSubjectSelectedItems, function(data, index) {
                $scope.list.RELEVANTSPECIALDOC.push({
                    METADATAID: data.METADATAID,
                    SPECIALGROUPID: data.SPECIALGROUPID,
                });
            });
            $scope.list.RELEVANTSPECIALDOC = jsonArrayToStringService.clearEmptyArray($scope.list.RELEVANTSPECIALDOC);
        }

        /**
         * [dealAttributeAfterSave description]保存成功后处理属性
         * @param  {[obj]} data [description]保存成功后的返回值
         * @param  {[boolean]} flag [description]标示位
         * @return {[type]}      [description]
         */
        function dealAttributeAfterSave(data, flag) {
            $scope.status.openBtn = true;
            $state.params.appchnldocid = $scope.list.CHNLDOCID = data.CHNLDOCID;
            $state.params.appmetadataid = $scope.list.METADATAID = data.METADATAID;
            if (flag) {
                if (!$scope.status.isFusionEditor) {
                    storageListenerService.addListenerToApp('save');
                    $state.transitionTo($state.current, $state.params, {
                        reload: false,
                    });
                    $timeout(function() {
                        modalDialog.saveModel('保存成功', '', 'success');
                    }, 500);
                }
            } else {
                $scope.params.MetaDataIds = $scope.list.METADATAID;
                $scope.params.CHNLDOCIDS = $scope.list.CHNLDOCID;
                $scope.params.ObjectIds = $scope.list.CHNLDOCID;
                $scope.params.serviceid = 'mlf_appoper';
            }
        }

        /**
         * [save description]保存函数
         * @param  {[boolean]} flag [description]标示位
         * @return {[type]}      [description]
         */
        function save(flag) {
            var deferred = $q.defer();
            $validation.validate($scope.webForm.authorForm);
            $validation
                .validate($scope.webForm)
                .success(function() {
                    editingCenterAppService
                        .examineImageRatio($scope.list, $scope.data, $scope.status, 'WEBPAGESIZE', 'WEBPAGEBIGSIZE', 'WEBZTPICSIZE')
                        .then(function() {
                            modalDialog.isSecretInformation(
                                $state.params.appmetadataid,
                                function() {
                                    sensitiveWordCheckService.sensitiveWords($scope).then(
                                        function(sensitiveWords) {
                                            $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                            $scope.list.SENSITIVEWORDS = sensitiveWords;
                                            var list = dealAttributeBeforeSave();
                                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                                function(data) {
                                                    dealAttributeAfterSave(data, flag);
                                                    beforeonload.refresh($scope);
                                                    deferred.resolve(data);
                                                },
                                                function(data) {
                                                    $scope.status.openBtn = true;
                                                    deferred.reject(data);
                                                }
                                            );
                                        },
                                        function() {
                                            $scope.status.isCheckSensitiveWords = Math.random();
                                            deferred.reject();
                                        }
                                    );
                                },
                                function() {
                                    deferred.reject();
                                },
                                $scope.status.isFusionEditor
                            );
                        });
                })
                .error(function() {
                    editingCenterService.checkSaveError($scope.webForm, $element, $scope); // 定位输入错的表单位置
                    deferred.reject();
                });
            return deferred.promise;
        }

        /**
         * [initBtnArray description]初始化功能按钮
         * @return {[type]} [description]
         */
        function initBtnArray() {
            if ($scope.status.isawaitrevise) {
                // 待修订状态的编辑页只有保存按钮和修订按钮，在此处加入保存按钮
                addBtn();
                return;
            }
            // 所需的按钮
            $scope.data.appRequiredBtns = initAppRequiredBtnService.initAppRequiredBtns()[$state.params.appplatform];
            // 根据不同平台调用不同权限方法
            $scope.data.rightsMethod = ['app.daibian', 'app.daishen', 'app.yiqianfa'];
            initeditctrBtnsService.initAppData($state.params.appchannelid, $scope.data.rightsMethod[$state.params.appplatform]).then(function(data) {
                // 字典按钮
                $scope.data.dictionaryBtn = [
                    appDictionaryBtnService.initAppCompBtn(),
                    appDictionaryBtnService.initAppPendBtn(),
                    appDictionaryBtnService.initAppSignBtn(),
                ];
                initeditctrBtnsService.initBtns(data, $scope.data.dictionaryBtn[$state.params.appplatform]).then((btns) => {
                    $scope.status.btnStatus = btns;
                    // 最终得到的按钮
                    $scope.data.arrayBtn = filterEditctrBtnsService.filterBtn($scope.status.btnStatus, $scope.data.appRequiredBtns);
                    checkSiteCanSaveAndPub().then(function() {
                        addBtn();
                    });
                });
            });
            // 错别字校对按钮权限
            editcenterRightsService.initAppListBtn('app.daishen', $state.params.appchannelid).then(function(data) {
                $scope.status.hasHeimaRight = !!data['app.daishen.check'] ? 'true' : 'false';
            });
        }

        /**
         * [checkSiteCanSaveAndPub description] 校验站点是否设置了不显示“保存并发布”按钮
         * @return {[type]} [description]
         */
        function checkSiteCanSaveAndPub() {
            var defer = $q.defer();
            if ($state.params.appplatform == 2) {
                var params = {
                    serviceid: 'mlf_appconfig',
                    methodname: 'canSaveAndPub',
                    SiteId: $state.params.appsiteid,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    var isNotShow = data.substring(1, data.indexOf('"', 1));
                    if (isNotShow == 'true') {
                        var hasPubSave = false;
                        var hasPubSaveIndex;
                        angular.forEach($scope.data.arrayBtn, function(value, key) {
                            // 判断是否含有保存并发布按钮
                            if (value.RIGHTINDEX == 419) {
                                hasPubSave = true;
                                hasPubSaveIndex = key;
                            }
                        });
                        if (hasPubSave === true) {
                            // 在已签发平台删除保存并发布按钮
                            $scope.data.arrayBtn.splice(hasPubSaveIndex, 1);
                        }
                    }
                    defer.resolve();
                });
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        /**
         * [addBtn description] 新增保存关闭按钮
         * @return  {[type]}  [return description]
         */
        function addBtn() {
            $scope.data.arrayBtn = $scope.data.arrayBtn ? $scope.data.arrayBtn : [];
            var OPERDESC = ['保存', '保存'];
            var OPERFUN = ['save', 'save'];
            if ($state.params.appplatform < 2) {
                $scope.data.arrayBtn.unshift({
                    RIGHTINDEX: 'save',
                    OPERDESC: OPERDESC[$state.params.appplatform],
                    OPERNAME: '',
                    OPERFUN: OPERFUN[$state.params.appplatform],
                });
            }
            // $scope.data.arrayBtn.push({
            //     RIGHTINDEX: "close",
            //     OPERDESC: "关闭",
            //     OPERNAME: "",
            //     OPERFUN: "close"
            // });
        }

        /**
         * [appSecondReview description] 已签发平台二次送审
         * @return {[type]} [description]
         */
        $scope.appSecondReview = function() {
            if ($scope.status.isSecondReview === true) {
                modalDialog.alertType('无法进行操作', '该稿件处于二次送审流程中，不能重复送审', 'warning', 'confirm');
                return;
            }
            modalDialog.confirmModal('二次送审', '确认送审稿件', function() {
                appSecondReview();
            });
        };

        /**
         * [appSecondReview description] 二次送审函数(不做保存，但把保存方法里的稿件信息全部作为参数传过去)
         * @param  {[type]} metadataid [description]
         * @return {[type]}            [description]
         */
        function appSecondReview() {
            $validation
                .validate($scope.webForm)
                .success(function() {
                    sensitiveWordCheckService.sensitiveWords($scope).then(
                        function(sensitiveWords) {
                            $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                            $scope.list.SENSITIVEWORDS = sensitiveWords;
                            var list = dealAttributeBeforeSave();
                            list.serviceid = 'mlf_appoper';
                            list.methodname = 'makeNewDuplication';
                            list.MetaDataId = list.METADATAID;
                            list.ChannelId = list.CHANNELID;
                            delete list.METADATAID;
                            delete list.CHANNELID;
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                function(data) {
                                    if (data.ISSUCCESS == 'true') {
                                        modalDialog.alertType(
                                            '二次送审成功',
                                            '',
                                            'success',
                                            false,
                                            function() {
                                                $scope.status.isSecondReview = true;
                                                storageListenerService.addListenerToApp('secondReview');
                                                $window.close();
                                            },
                                            '',
                                            1500
                                        );
                                    } else {
                                        modalDialog.alertType('二次送审失败', '', 'error', 'confirm');
                                    }
                                },
                                function(data) {
                                    $scope.status.openBtn = true;
                                    modalDialog.alertType('二次送审失败', '', 'error', 'confirm');
                                }
                            );
                        },
                        function() {
                            $scope.status.isCheckSensitiveWords = Math.random();
                        }
                    );
                })
                .error(function() {
                    editingCenterService.checkSaveError($scope.webForm); // 定位输入错的表单位置
                });

        }
        // 可视化选择弹窗
        $scope.visualChooseWindow = function(type) {
            trsSelectDocumentService.trsSelectDocument(
                {
                    siteid: $state.params.appsiteid,
                    relNewsData: type === 'relSubjectSelectedItems' ? [] : angular.copy($scope.data[type]),
                    position: $state.params.appplatform,
                    showMetadaId: true,
                    isApp: true,
                    docType: '3',
                    searchSpecialDoc: type === 'relSubjectSelectedItems',
                    platform: 7,
                },
                function(result) {
                    if (type == 'relNewsSelectedItems') {
                        angular.forEach(result, function(value, key) {
                            value.METADATAID = value.metadataId;
                            value.LISTTITLE = value.title;
                        });
                        $scope.data[type] = result;
                    } else {
                        var i = 0;
                        var index = $scope.data[type].length;
                        var hasGroupArray = [];
                        queryRelSubjectGroup(result[i], function() {
                            $scope.data[type] = $scope.data[type].concat(hasGroupArray);
                        });
                    }

                    /**
                     * [queryRelSubjectGroup description] 请求相关专题稿件的分组
                     * @param  {[type]}   item     [description] 当前稿件
                     * @param  {Function} callback [description] 回调函数
                     * @return {[type]}            [description]
                     */
                    function queryRelSubjectGroup(item, callback) {
                        item.METADATAID = item.metadataId;
                        item.LISTTITLE = item.title;
                        var params = {
                            methodname: 'querySpecialGroupsFromData',
                            serviceid: 'mlf_specialgroup',
                            MetaDataId: item.METADATAID,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                            if (data.DATA.length === 0) {
                                modalDialog.alertType('相关专题"' + item.LISTTITLE + '"没有分组', '', 'error', 'confirm');
                                i++;
                            } else {
                                $scope.data.relSubjectGroup[index] = data.DATA;
                                angular.forEach($scope.data.relSubjectGroup[index], function(value, key) {
                                    value.name = value.SPECIALGROUPNAME;
                                    value.value = value.SPECIALGROUPID;
                                });
                                $scope.data.relSubjectSelectedGroup[index] = $scope.data.relSubjectGroup[index][0];
                                item.SPECIALGROUPID = $scope.data.relSubjectGroup[index][0].SPECIALGROUPID;
                                hasGroupArray.push(item);
                                i++;
                                index++;
                            }
                            if (i < result.length) {
                                queryRelSubjectGroup(result[i], callback);
                            } else {
                                callback();
                            }
                        });
                    }
                }
            );
        };

        /**
         * [darftRemove description] 数组去重
         * @param   {[type]}  selectArray  [selectArray description]
         * @param   {[type]}  dataArray    [dataArray description]
         * @param   {[type]}  type         [type description]
         * @param   {[type]}  callback     [callback description]
         * @return  {[type]}               [return description]
         */
        function darftRemove(selectArray, dataArray, type, callback) {
            var arr = selectArray.concat(dataArray);
            var lastArr = [];
            var num = 0;
            for (var i = 0; i < arr.length; i++) {
                if (!unique(arr[i][type], lastArr, type)) {
                    lastArr.push(arr[i]);
                } else {
                    if (angular.isFunction(callback)) {
                        callback(i - num);
                        num++;
                    }
                }
            }
            return lastArr;
        }

        /**
         * [unique description]
         * @param   {[type]}  n     [n description]
         * @param   {[type]}  arr   [arr description]
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        function unique(n, arr, type) {
            for (var i = 0; i < arr.length; i++) {
                if (n == arr[i][type]) {
                    return true;
                }
            }
            return false;
        }
        // 选择相关新闻或专题
        $scope.selectManuscript = function(item, type) {
            if ($scope.data.selectSubjectArray.indexOf(item) < 0) {
                $scope.data.selectSubjectArray.push(item);
            } else {
                $scope.data.selectSubjectArray.splice($scope.data.selectSubjectArray.indexOf(item), 1);
            }
        };

        /**
         * [selectAll description] 稿件全选
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.selectAll = function(type) {
            $scope.data.selectSubjectArray =
                $scope.data.selectSubjectArray.length == $scope.data.relSubjectSelectedItems.length
                    ? []
                    : [].concat($scope.data.relSubjectSelectedItems);
        };

        /**
         * [manuscriptDelete description] 删除已选稿件
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.manuscriptDelete = function(type) {
            var index;
            for (var i = 0; i < $scope.data.selectSubjectArray.length; i++) {
                index = $scope.data.relSubjectSelectedItems.indexOf($scope.data.selectSubjectArray[i]);
                $scope.data.relSubjectSelectedItems.splice(index, 1);
            }
            $scope.data.selectSubjectArray.length = 0;
        };

        /**
         * [selectRelSubjectGroup description] 选择相关专题稿件的分组
         * @param   {[type]}  item           [item description]
         * @param   {[type]}  selectedGroup  [selectedGroup description]
         * @return  {[type]}                 [return description]
         */
        $scope.selectRelSubjectGroup = function(item, selectedGroup) {
            item.SPECIALGROUPID = selectedGroup.value;
        };

        // 清空相关联稿件
        $scope.cleanRelatedNews = function(type) {
            $scope.data[type] = [];
            if (type === 'relSubjectSelectedItems') {
                $scope.data.relSubjectGroup = [];
                $scope.data.relSubjectSelectedGroup = [];
            }
        };

        // 删除相关新闻或专题
        $scope.relNewsDelete = function(curIndex, type) {
            var index = $scope.data[type].indexOf(curIndex);
            $scope.data[type].splice(index, 1);
            if (type === 'relSubjectSelectedItems') {
                $scope.data.relSubjectGroup.splice(index, 1);
                $scope.data.relSubjectSelectedGroup.splice(index, 1);
            }
        };

        /**
         * [getSrcUrl description] 由稿件链接获取稿件页面
         * @return {[type]} [description]
         */
        $scope.getSrcUrl = function() {
            $scope.data.srcUrl = $sce.trustAsResourceUrl($scope.list.URL);
        };
        // 原创声明
        $scope.oringin = function(list) {
            if (list.ORIGINAL === '1') {
                $scope.list.ORIGINAL = '0';
                $scope.data.originType = '0';
            } else {
                $('.newsResourcesTips')
                    .find('.tips')
                    .remove();
                $scope.list.ORIGINAL = '1';
                $scope.data.originType = $scope.data.originList[0].value;
                $scope.data.specialDoc = 0;
            }
        };
        // 点击特殊稿
        $scope.specialDoc = function() {
            if ($scope.data.specialDoc == 1) {
                $scope.data.specialDoc = 0;
            } else {
                $('.newsResourcesTips')
                    .find('.tips')
                    .remove();
                $scope.data.specialDoc = 1;
                $scope.list.ORIGINAL = '0';
                $scope.data.originType = '0';
            }
        };
        // 勾选原创稿二级单选的原创类型
        $scope.checkOrigin = function(item) {
            $('.newsResourcesTips')
                .find('.tips')
                .remove();
            $scope.data.originType = item.value;
            $scope.list.ORIGINAL = '1';
            $scope.data.specialDoc = 0;
        };

        /* 融合编辑器额外功能开始*/
        if ($scope.status.isFusionEditor) {

            /**
             * [pageCantEdit description] 已提交渠道编辑页不能编辑
             * @param  {[type]} type [description] 稿件信息或属性信息
             * @return {[type]}      [description]
             */
            $scope.pageCantEdit = function(type) {
                $timeout(function() {
                    if (type === 'manuscriptInfo') {
                        var manuHeight = $('.app_manuscript_info').height();
                        var manuWidth = $('.app_manuscript_info').width();
                        $('.pageCantEdit')
                            .find('.cantEditPart')
                            .height(manuHeight)
                            .width(manuWidth);
                        $('.app_manuscript_info').resize(function() {
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height($(this).height());
                        });
                    } else if (type === 'attrInfo') {
                        var attrHeight = $('.app_attr_info').height();
                        var attrWidth = $('.app_attr_info').width();
                        $('.pageCantEdit')
                            .find('.cantEditPart')
                            .height(attrHeight)
                            .width(attrWidth);
                        $('.app_attr_info').resize(function() {
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height($(this).height());
                        });
                    }
                }, 300);
            };

            /**
             * [initData description] 融合编辑器切换渠道时的初始化数据
             * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
             * @return {[type]} [description]
             */
            $scope.initData = function(dealWithListFun) {
                var defer = $q.defer();
                if (angular.isDefined($state.params.appchnldocid)) {
                    initEditData(dealWithListFun).then(function() {
                        defer.resolve();
                    });
                } else {
                    initNewData(dealWithListFun).then(function() {
                        defer.resolve();
                    });
                }
                return defer.promise;
            };

            /**
             * [loadFgd description] 加载发稿单
             * @return {[type]} [description]
             */
            $scope.loadFgd = function() {
                var draftList =
                    '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="webForm"></editor-dir>' +
                    '<editor-auth-dir originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0" author="list.FGD_AUTHINFO"></editor-auth-dir>';
                draftList = $compile(draftList)($scope);
                $element.find('editor').append(draftList);
            };
        }

        /* 融合编辑器额外功能结束*/

        /**
         * [syncTitleToListTitle 将文章标题同步给列表标题]
         *
         * @return  {[type]}  [return description]
         */
        $scope.syncTitleToListTitle = function() {
            syncTitleToListTitle();
        };

        /**
         * [syncTitleToListTitle 将文章标题同步给列表标题实现]
         *
         * @return  {[type]}  [return description]
         */
        function syncTitleToListTitle() {
            if ($scope.status.hasTitleSynced) {
                return;
            } else {
                if ($scope.list.LISTTITLE !== '') {
                    return;
                } else {
                    $scope.list.LISTTITLE = $scope.list.TITLE;
                    $scope.status.hasTitleSynced = true;
                }
            }
        }
        $scope.checkNetHead = function() {
            $scope.returnParams = editingCenterService.checkHasNetHead($scope.list.URL);
            $scope.status.showAddHeadTips = $scope.returnParams.hasHead === false;
            $scope.list.URL = $scope.returnParams.url;
        };
        $scope.goToPreviewLink = function() {
            window.open($scope.list.URL);
        };
    },
]);
